import { Client } from './client.model';

export interface Product {
  createdBy?: any;
  creationDate?: any;
  lastModifiedBy?: any;
  lastModifiedDate?: any;
  reference?: any;
  productId?: number;
  availableForSales?: boolean;
  destinationCode?: number;
  name?: string;
  detail?: string;
  producType?: any;
  contents?: any[];
  photos?: any[];
  rateGroups?: any[];
  tags?: string;
  ratings?: any[];
  customerRating?: any[];
  contratc?: any;
  tax?: any;
  supplier?: Client;
}

export class ProductCtor implements Product {
  createdBy?: any;
  creationDate?: any;
  lastModifiedBy?: any;
  lastModifiedDate?: any;
  reference?: any;
  productId?: number;
  availableForSales?: boolean;
  destinationCode?: number;
  name?: string;
  detail?: string;
  producType?: any;
  contents?: any[];
  photos?: any[];
  rateGroups?: any[];
  tags?: string;
  ratings?: any[];
  customerRating?: any[];
  contratc?: any;
  tax?: any;
  supplier?: Client;
  user?:Client
  unitType?:any;

  public constructor(fields?: {
    createdBy?: any;
    creationDate?: any;
    lastModifiedBy?: any;
    lastModifiedDate?: any;
    reference?: any;
    productId?: number;
    availableForSales?: boolean;
    destinationCode?: number;
    name?: string;
    detail?: string;
    producType?: any;
    contents?: any[];
    salesSpitch?: any[];
    photos?: any[];
    rateGroups?: any[];
    tags?: any[];
    ratings?: any[];
    customerRating?: any[];
    contratc?: any;
    tax?: any;
    supplier?: Client;
    prices?: any[];
    user?:Client;
    unitType?:string
  }) {
    if (fields) Object.assign(this, fields);
  }
}
